import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-schedule-plan-sidenav",
  templateUrl: "./schedule-plan-sidenav.component.html",
})
export class SchedulePlanSidenavComponent implements OnInit {
  selectedlang: any = {};
  tcCode = "";
  testCenterName = "";
  usertype: any = "";
  subscriptionstatus = false;
  accessManagement: any = [];
  accessManagements: any = [];
  dashboardMenu: any = {
    creditcardappointmentmenu: false,
    billingappointmentmenu: false,
  };
  currentURL: any = "";
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.subscriptionstatus =
      localStorage.getItem("subscriptionflag") &&
      localStorage.getItem("subscriptionflag") == "true"
        ? true
        : false;

    if (this.subscriptionstatus) {
      this.accessManagement = JSON.parse(
        localStorage.getItem("accessmanagement")
      );
      this.setaccessmanagement(this.accessManagement);
    } else if (!this.subscriptionstatus) {
      if (localStorage.getItem("accessmanagement")) {
        this.accessManagement = JSON.parse(
          localStorage.getItem("accessmanagement")
        );
        this.setaccessmanagement(this.accessManagement);
      } else {
        this.getAccessManagement();
      }
    }

    this.usertype = sessionStorage.getItem("usertype");

    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }

    if (localStorage.getItem("testCenterName") != null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
  }

  getAccessManagement() {
    this.appservice.getFrontDeskAccessManagement().subscribe((res) => {
      if (res && res["entity"] && res["entity"].length > 0) {
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy =
            res["entity"][index]["accessManagement"]["accessType"];
          this.accessManagements[index] = res["entity"][index];
          this.accessManagements[index].groupBy = groupBy;
        }
        this.accessManagement = this.groupBy(this.accessManagements, "groupBy");
        this.setaccessmanagement(this.accessManagement);
      }
    });
  }

  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }

  setaccessmanagement(access) {
    for (let i = 0; i < access.length; i++) {
      if (access[i].value.length > 0 && access[i].key === "Admin") {
        for (let j = 0; j < access[i].value.length; j++) {
          if (sessionStorage.getItem("usertype") == "2") {
            if (access[i].value[j].accessManagement.subMenu == "Credit Card") {
              this.dashboardMenu.creditcardappointmentmenu =
                access[i].value[j].admin;
            } else if (
              access[i].value[j].accessManagement.accessManagement == "Billing"
            ) {
              this.dashboardMenu.billingappointmentmenu =
                access[i].value[j].admin;
            }
          } else if (sessionStorage.getItem("usertype") == "3") {
            if (access[i].value[j].accessManagement.subMenu == "Credit Card") {
              this.dashboardMenu.creditcardappointmentmenu =
                access[i].value[j].frontDesk;
            } else if (
              access[i].value[j].accessManagement.accessManagement == "Billing"
            ) {
              this.dashboardMenu.billingappointmentmenu =
                access[i].value[j].frontDesk;
            }
          }

          if (j + 1 === access[i].value.length) {
            if (this.dashboardMenu.billingappointmentmenu) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.checkURL("credit-card");
              } else {
                this.checkURL("plan-subscription");
              }
            } else if (this.dashboardMenu.creditcardappointmentmenu) {
              if (sessionStorage.getItem("usertype") === "3") {
                this.checkURL("billing-summary");
              } else {
                this.checkURL("plan-subscription");
              }
            }
          }
        }
      }
    }
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
